// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Tells the inline head script that the bundle booted, so it leaves the
// `data-js` flag in place and the CSS-hidden fallback controls stay hidden.
document.documentElement.dataset.jsReady = "true"
